import React from "react";
import { Button } from "../../../../../ui/components/Button";
import type { ActionRequiredItemEntity } from "../../../domain/entities/BooksHealthEntity";
import { truncateText } from "../../../../../shared/utils/formatters";

export interface ActionRequiredQueryCardProps extends ActionRequiredItemEntity {
  onAction?: () => void;
}

export function ActionRequiredQueryCard({
  title,
  description,
  raisedBy,
  date,
  type,
  onAction,
}: ActionRequiredQueryCardProps) {
  const isQuery = type === "query";
  const borderClass = isQuery ? "border-l-error-600" : "border-l-brand-600";
  const buttonVariant = isQuery ? "destructive-primary" : "brand-primary";
  const buttonLabel = isQuery ? "Reply to Query" : "Review Bills";

  return (
    <div
      className={`flex w-full items-center justify-between rounded-lg border border-solid border-neutral-200 bg-white px-6 py-5 ${borderClass}`}
    >
      <div className="flex max-w-[620px] flex-col items-start gap-1">
        <span className="text-body-bold font-body-bold text-neutral-900">
          {title}
        </span>
        <span className="max-w-full text-body font-body text-neutral-500">
          {truncateText(description, 100)}
        </span>
        <span className="text-caption font-caption text-neutral-400">
          {raisedBy} · {date}
        </span>
      </div>
      <Button
        variant={buttonVariant}
        size="medium"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          onAction?.();
        }}
      >
        {buttonLabel}
      </Button>
    </div>
  );
}
